export default "__VITE_ASSET__e2a0f72f__"